import * as React from "react";
import { IdStyles } from "../../../less/IdStyles";
export var ImageBoxContainer = function (_a) {
    var children = _a.children, className = _a.className;
    // TODO: Explore the best option for displaying different sizes containers.
    return (React.createElement("div", { className: "" + (className ? className : IdStyles.ImageBoxContainer) }, children));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/generic/common/ImageBoxContainer.tsx
// module id = 442
// module chunks = 3